.riskListing {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.assessmentSection {
    margin: 20px 0px;
}

.stat {
    width: 33%;
    display: flex;
    flex-direction: column;
}

.detailContainer {
    display: flex;
    justify-content: space-between;
}
